var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCloseWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "3xb7h93baa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.750000 0 0 0 0 0.750000 0 0 0 0 0.750000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-652 -36)",
    filter: "url(#3xb7h93baa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.3 57.7a1.167 1.167 0 0 1-.08-1.562l.08-.088 6.05-6.05-6.05-6.05a1.167 1.167 0 0 1 1.562-1.73l.088.08 6.05 6.05 6.05-6.05a1.167 1.167 0 0 1 1.73 1.562l-.08.088-6.05 6.05 6.05 6.05a1.167 1.167 0 0 1-1.562 1.73l-.088-.08-6.05-6.05-6.05 6.05a1.167 1.167 0 0 1-1.65 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCloseWhite);
export default __webpack_public_path__ + "static/media/btn-close-white.b044d18c5efbea26ac0ec229e8b5b5df.svg";
export { ForwardRef as ReactComponent };